module.exports = __webpack_public_path__ + "static/media/Bio_essence.5eece5d0.svg";